import React from 'react'
import { Link } from 'react-router-dom'

const WomenOfChaashni = () => {
  return (
<div className='womenofchaashni'>
  <div className='flare-black'><img src='images/about/flare-black.png' alt='' /></div>
<div className="category-full">
  <div className="container">
    <ul>     
      <li>
        <div className="img-box"><Link to="/category/shop?shipping=7+Days_Within+7+days&orderBy=default">
        <picture>  
          <source media="(min-width:1199px)"  srcset={`${process.env.REACT_APP_IMAGE_URL}womenofchaashni/ready-to-ship.jpg`} />
          <img src={`${process.env.REACT_APP_IMAGE_URL}womenofchaashni/ready-to-ship-mobile.jpg`} alt="Ready To Ship Styles" width="100%" height="auto" />
        </picture> 
        </Link></div>
        {/* <h2><Link to="the-women-of-chaashni" className="newfont-heading">The Women of Chaashni</Link></h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/> Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        <div className="viewmorebtn"><Link to="clientdiaries">EXPLORE</Link></div> */}
      </li>
      <li>
        <div className="img-box">{/* <Link to="#"> */}
        <picture>
          <source media="(min-width:1199px)"  srcset={`${process.env.REACT_APP_IMAGE_URL}womenofchaashni/fri-yay-sale.jpg`} />
          <img src={`${process.env.REACT_APP_IMAGE_URL}womenofchaashni/fab-friday-mobile.jpg`} alt="Fri Yay Sale"  width="100%" height="auto" />
        </picture>{/* </Link> */}</div>
        {/* <h2><Link to="/category/shop?shipping=7+Days_Within+7+days&orderBy=default" className="newfont-heading">Ready To Ship Styles at Special Prices</Link></h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/> Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        <div className="viewmorebtn"><Link to="/category/shop?shipping=7+Days_Within+7+days&orderBy=default">EXPLORE</Link></div> */}
      </li>
    </ul>
  </div>
</div>
</div>

  )
}

export default WomenOfChaashni
